/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFooterColumnFragment, FooterColumnFragment, FullFooterColumnFragment} from '@amblique/contentful/app/contentful/fragments/footer-column';

/**
 * Get a single FooterColumn by ID (base - scalars only)
 */
export const getBaseFooterColumnById = gql`
  ${BaseFooterColumnFragment}

  query GetBaseFooterColumnById($id: String!, $locale: String!, $preview: Boolean) {
    footerColumn(id: $id, locale: $locale, preview: $preview) {
      ...BaseFooterColumnFragment
    }
  }
`;

/**
 * Get a single FooterColumn by ID (standard - 1 level deep)
 */
export const getFooterColumnById = gql`
  ${FooterColumnFragment}

  query GetFooterColumnById($id: String!, $locale: String!, $preview: Boolean) {
    footerColumn(id: $id, locale: $locale, preview: $preview) {
      ...FooterColumnFragment
    }
  }
`;

/**
 * Get a single FooterColumn by ID (full - 2 levels deep)
 */
export const getFullFooterColumnById = gql`
  ${FullFooterColumnFragment}

  query GetFullFooterColumnById($id: String!, $locale: String!, $preview: Boolean) {
    footerColumn(id: $id, locale: $locale, preview: $preview) {
      ...FullFooterColumnFragment
    }
  }
`;

/**
 * Get all FooterColumn entries with pagination (base - scalars only)
 */
export const getBaseFooterColumns = gql`
  ${BaseFooterColumnFragment}

  query GetBaseFooterColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterColumnOrder]
    $where: FooterColumnFilter
    $preview: Boolean
  ) {
    footerColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFooterColumnFragment
      }
    }
  }
`;

/**
 * Get all FooterColumn entries with pagination (standard - 1 level deep)
 */
export const getFooterColumns = gql`
  ${FooterColumnFragment}

  query GetFooterColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterColumnOrder]
    $where: FooterColumnFilter
    $preview: Boolean
  ) {
    footerColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FooterColumnFragment
      }
    }
  }
`;

/**
 * Get all FooterColumn entries with pagination (full - 2 levels deep)
 */
export const getFullFooterColumns = gql`
  ${FullFooterColumnFragment}

  query GetFullFooterColumns(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FooterColumnOrder]
    $where: FooterColumnFilter
    $preview: Boolean
  ) {
    footerColumnCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFooterColumnFragment
      }
    }
  }
`;
